import { useTranslation } from "react-i18next";
import { Loader } from "semantic-ui-react";

import { SearchResultRow, SearchResultsDivider } from "components/NavBarSearchAppointments/components";
import "components/NavBarSearchAppointments/components/SearchDropdown/SearchDropdown.scss";

import type { SEARCH_OPTION_TYPE, SearchResultsData } from "components/NavBarSearchAppointments/util";

type SearchResultLocationsProps = {
  data: SearchResultsData;
  isImportAppointmentPending: boolean;
  isFetchingAppointments: boolean;
  selectedId: string | null;
  handleOnClick: (id: string, type: SEARCH_OPTION_TYPE) => void;
};

export const SearchResultLocations = ({ data, handleOnClick, isImportAppointmentPending, isFetchingAppointments, selectedId }: SearchResultLocationsProps) => {
  const { t } = useTranslation();

  if (!isFetchingAppointments && !data.currentLocation.length && !data.otherLocations.length)
    return (
      <div className="no-result">
        <p>{t("v8_no_results_found", "No results found")}</p>
      </div>
    );

  return (
    <>
      {data.currentLocation.map(item => (
        <SearchResultRow handleOnClick={handleOnClick} isImportAppointmentPending={isImportAppointmentPending} selectedId={selectedId} key={item.id} item={item} />
      ))}
      {data.otherLocations.length > 0 && (
        <>
          <SearchResultsDivider />
          {data.otherLocations.map(item => (
            <SearchResultRow handleOnClick={handleOnClick} isImportAppointmentPending={isImportAppointmentPending} selectedId={selectedId} key={item.id} item={item} />
          ))}
        </>
      )}
      {isFetchingAppointments && (
        <div className="search-loader">
          <Loader active inline size="small" />
        </div>
      )}
    </>
  );
};
